import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBriefcase, faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons/faCirclePlus";
import EmployeeAvailability from "./EmployeeAvailability";
import { employeeAvailabilityDefault } from "../../../../defaults/Items";
import useAuth from "../../../../hooks/useAuth";

const EmployeeAvailabilitiesCard = ({ state }) => {
  const navigate = useNavigate();
  const { auth } = useAuth();
  const currentItem = state.currentItem;
  const employeeAvailabilities = currentItem?.employeeAvailabilities?.slice() || [];
  const setCurrentItem = state.setCurrentItem;
  const setItemChanged = state.setItemChanged;
  const itemChanged = state.itemChanged;
  const [isAccordionOpen, setIsAccordionOpen] = useState(true);
  const userRoles = Array.isArray(auth?.roles)
    ? auth.roles
    : typeof auth?.roles === "string"
      ? auth.roles.replace(/[\[\]\s]/g, "").split(",")
      : [];
  const canManageSeasonality = userRoles.includes("ROLE_ADMIN") || userRoles.includes("ROLE_MANAGER");

  const markChanged = (updatedAvailabilities) => {
    setCurrentItem({ ...currentItem, employeeAvailabilities: updatedAvailabilities });
    setItemChanged(!itemChanged);
  };

  const onInputChange = (e, availability, field) => {
    const updatedAvailabilities = employeeAvailabilities.map(item =>
      item.id === availability.id ? { ...item, [field]: e.target.value } : item
    );
    markChanged(updatedAvailabilities);
  };

  const onWeekdayChange = (availability, day) => {
    const days = Array.isArray(availability.daysOfWeek) ? availability.daysOfWeek : [];
    const nextDays = days.includes(day) ? days.filter(item => item !== day) : [...days, day];
    const updatedAvailabilities = employeeAvailabilities.map(item =>
      item.id === availability.id ? { ...item, daysOfWeek: nextDays } : item
    );
    markChanged(updatedAvailabilities);
  };

  const addAvailability = () => {
    const existingIds = employeeAvailabilities.map(item => item.id);
    let newId = -1;
    while (existingIds.includes(newId)) newId--;
    markChanged([
      ...employeeAvailabilities,
      { ...employeeAvailabilityDefault, EID: currentItem.id, id: newId, daysOfWeek: [] }
    ]);
  };

  const removeAvailability = (availabilityId) => {
    markChanged(employeeAvailabilities.filter(item => item.id !== availabilityId));
  };

  const openSeasonality = () => {
    const params = new URLSearchParams();
    params.set("seasonality", "1");
    params.set("employeeId", String(currentItem.id));
    if (currentItem?.department?.id) params.set("departmentId", String(currentItem.department.id));
    navigate(`/app/employee-availability-schedule?${params.toString()}`);
  };

  return (
    <div className="card">
      <div className="card-header d-flex align-items-center justify-content-between" onClick={() => setIsAccordionOpen(!isAccordionOpen)} style={{ cursor: "pointer" }}>
        <div className="d-flex align-items-center">
          <FontAwesomeIcon icon={faBriefcase} className="me-2 header-icon" />
          <span>Niestandardowa dostępność pracownika {!isAccordionOpen ? `(${employeeAvailabilities.length})` : ""}</span>
        </div>
        <FontAwesomeIcon icon={isAccordionOpen ? faChevronUp : faChevronDown} />
      </div>

      <div className={`card-body ${isAccordionOpen ? "show" : "offscreen"}`} id="employeeAvailabilities">
        <div className="d-flex flex-wrap gap-2 mb-3">
          <button type="button" className="btn-auxiliary btn-primary" onClick={addAvailability}>
            <FontAwesomeIcon icon={faCirclePlus} /> Dodaj okres
          </button>
          {canManageSeasonality && Number(currentItem?.id) > 0 && (
            <button type="button" className="btn btn-outline-primary" onClick={openSeasonality}>
              Sterowanie sezonowością
            </button>
          )}
        </div>

        {employeeAvailabilities.length === 0 ? (
          <p>Brak niestandardowych okresów dostępności.</p>
        ) : (
          <div className="d-flex flex-column gap-3">
            {employeeAvailabilities.map((availability, index) => (
              <EmployeeAvailability
                key={availability.id ?? index}
                availability={availability}
                index={index}
                readOnly={availability.entrySource === "SEASONAL"}
                onInputChange={onInputChange}
                onWeekdayChange={onWeekdayChange}
                onRemove={() => removeAvailability(availability.id)}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default EmployeeAvailabilitiesCard;

